(function($){

	$(document).ready(function() {
        
        //Accordion
        $('.accordion').find('.accordion-title').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).next().slideToggle('fast');
        });
        
	});
})(jQuery);